import { Route } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import Wisdom from "../pages/Wisdom";
import WisdomUserProfile from "../pages/WisdomUserProfile";
import WisdomDashboard from "../pages/WisdomDashboard";
import WisdomSystemInfo from "../pages/WisdomSystemInfo";
import Pms from "../pages/Pms";
import TeacherSubstitutions from "../pages/TeacherSubstitutions";
import TeacherLatness from "../pages/TeacherLatness";
import StudentAbsence from "../pages/StudentAbsence";
import StudentBehavior from "../pages/StudentBehavior";
import SchoolIncident from "../pages/SchoolIncident";
import Interview from "../pages/Interview";
import Test from "../pages/Test";
import Dms from "../pages/Dms";
// import Tms from "../pages/Tms";
import UploadDocument from "../pages/UploadDocument";
import ViewDocument from "../pages/ViewDocument";
// import Assign from "../pages/Assign";
import WisdomMyTasks from "../pages/WisdomMyTasks";
// import ViewTask from "../pages/ViewTask";
import WisdomPdms from "pages/wisdom/pdms/WisdomPdms";
import WisdomTmsDashboard from "pages/wisdom/tms/WisdomTmsDashboard";
import { AlarmProvider } from "context/AlarmContext";
import WisdomTmsAddTask from "pages/wisdom/tms/WisdomTmsAddTask";
import WisdomTmsEdit from "pages/wisdom/tms/WisdomTmsEdit";
import WisdomForm from "pages/wisdom/pms/WisdomForm";
import WisdomCreateGradeBook from "pages/wisdom/pms/WisdomCreateGradeBook";
import WisdomAdmin from "pages/wisdom/admin_panel/WisdomAdmin";
import WisdomInsertGradeBook from "pages/wisdom/pms/WisdomInsertGradeBook";
import WisdomPdmsDashboard from "pages/wisdom/pdms/WisdomPdmsDashboard";
import WisdomAdminEmployee from "pages/wisdom/admin_panel/WisdomAdminEmployee";
import WisdomAdminTeacherClassAssign from "pages/wisdom/admin_panel/WisdomAdminTeacherClassAssign";
import WisdomEmployeeAbsence from "pages/wisdom/pms/WisdomEmployeeAbsence";
import WisdomAdminEmployeeData from "pages/wisdom/admin_panel/WisdomAdminEmployeeData";
import WisdomAdminOrganization from "pages/wisdom/admin_panel/WisdomAdminOrganization";
import WisdomAdminOrganizationWorkshopTools from "pages/wisdom/admin_panel/WisdomAdminOrganizationWorkshopTools";
import WisdomAdminTeacherSubjectManage from "pages/wisdom/admin_panel/WisdomAdminTeacherSubjectManage";
import WisdomWAMM from "pages/wisdom/WisdomWAMM";

export const WisdomRoutes = () => [
    <Route key="wisdom main page" path="/wisdom" element={
        <ProtectedRoute>
            <Wisdom />
        </ProtectedRoute>
    } />,
    <Route key="wisdom user profile" path="/wisdom/user-profile" element={
        <ProtectedRoute>
            <WisdomUserProfile />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS" path="/pms" element={
        <ProtectedRoute>
            <Pms />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS form" path="/pms/form/:id" element={
        <ProtectedRoute>
            <WisdomForm />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS teacher substitution" path="/pms/teacher-substitutions" element={
        <ProtectedRoute>
            <TeacherSubstitutions />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS teacher latness" path="/pms/teacher-latness" element={
        <ProtectedRoute>
            <TeacherLatness />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS school incident" path="/pms/school-incident" element={
        <ProtectedRoute>
            <SchoolIncident />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS employee absence" path="/pms/employee-absence" element={
        <ProtectedRoute>
            <WisdomEmployeeAbsence />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS student absence" path="/pms/student-absence" element={
        <ProtectedRoute>
            <StudentAbsence />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS student behavior" path="/pms/student-behavior" element={
        <ProtectedRoute>
            <StudentBehavior />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS test" path="/pms/test" element={
        <ProtectedRoute>
            <Test />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS Create New Grade Book" path="/pms/create-gradebook" element={
        <ProtectedRoute>
            <WisdomCreateGradeBook />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS Insert Grade Book Scores" path="/pms/insert-gradebook-scores" element={
        <ProtectedRoute>
            <WisdomInsertGradeBook />
        </ProtectedRoute>
    } />,
    <Route key="wisdom dashboard" path="/wisdom/dashboard" element={
        <ProtectedRoute>
            <WisdomDashboard />
        </ProtectedRoute>
    } />,
    <Route key="wisdom admin" path="/wisdom/admin" element={
        <ProtectedRoute>
            <WisdomAdmin />
        </ProtectedRoute>
    } />,
    <Route key="wisdom admin employees" path="/wisdom/admin/employees" element={
        <ProtectedRoute>
            <WisdomAdminEmployee />
        </ProtectedRoute>
    } />,
    <Route key="wisdom admin teacher class assign" path="/wisdom/admin/employees/teacher-class-assign" element={
        <ProtectedRoute>
            <WisdomAdminTeacherClassAssign />
        </ProtectedRoute>
    } />,
    <Route key="wisdom admin teacher subject manage" path="/wisdom/admin/employees/teacher-subject-manage" element={
        <ProtectedRoute>
            <WisdomAdminTeacherSubjectManage />
        </ProtectedRoute>
    } />,
    <Route key="wisdom admin employee data" path="/wisdom/admin/employees/personal-data" element={
        <ProtectedRoute>
            <WisdomAdminEmployeeData />
        </ProtectedRoute>
    } />,
    <Route key="wisdom admin students" path="/wisdom/admin/students" element={
        <ProtectedRoute>
            <WisdomAdmin />
        </ProtectedRoute>
    } />,
    <Route key="wisdom admin organization" path="/wisdom/admin/organization" element={
        <ProtectedRoute>
            <WisdomAdminOrganization />
        </ProtectedRoute>
    } />,
    <Route key="wisdom admin organization workshop tools" path="/wisdom/admin/organization/workshop-tools" element={
        <ProtectedRoute>
            <WisdomAdminOrganizationWorkshopTools />
        </ProtectedRoute>
    } />,
    <Route key="wisdom system info" path="/wisdom/system-info" element={
        <ProtectedRoute>
            <WisdomSystemInfo />
        </ProtectedRoute>
    } />,
    <Route key="wisdom DMS" path="/dms" element={
        <ProtectedRoute>
            <Dms />
        </ProtectedRoute>
    } />,
    <Route key="wisdom DMS upload" path="/dms/upload" element={
        <ProtectedRoute>
            <UploadDocument />
        </ProtectedRoute>
    } />,
    <Route key="wisdom DMS view" path="/dms/view/:id" element={
        <ProtectedRoute>
            <ViewDocument />
        </ProtectedRoute>
    } />,
    <Route key="wisdom TMS" path="/tms" element={
        <ProtectedRoute>
            <AlarmProvider>
                <WisdomTmsDashboard />
            </AlarmProvider>
        </ProtectedRoute>
    } />,
    <Route key="wisdom TMS my tasks" path="/wisdom/tms/my-tasks" element={
        <ProtectedRoute>
            <WisdomMyTasks />
        </ProtectedRoute>
    } />,
    <Route key="wisdom Tms add task" path="/wisdom/tms/add-task" element={
        <ProtectedRoute>
            <WisdomTmsAddTask />
        </ProtectedRoute>
    } />,
    <Route key="wisdom TMS edit task" path="/wisdom/tms/edit/:id" element={
        <ProtectedRoute>
            <WisdomTmsEdit />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PDMS Home Page" path="/wisdom/pdms" element={
        <ProtectedRoute>
            <WisdomPdms />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PMS interview" path="/pdms/interview" element={
        <ProtectedRoute>
            <Interview />
        </ProtectedRoute>
    } />,
    <Route key="wisdom PDMS Dashboard" path="/wisdom/pdms/dashboard" element={
        <ProtectedRoute>
            <WisdomPdmsDashboard />
        </ProtectedRoute>
    } />,
    <Route key="wisdom WAMM" path="/wisdom/wamm" element={
        <ProtectedRoute>
            <WisdomWAMM />
        </ProtectedRoute>
    } />,
];